export default __webpack_public_path__ + "static/media/Template_3_dark.b1e59c04.svg";